
import * as network from './player';

export class logger implements network.sendStatus {
    constructor() {
    }

    public onChange(status) {
        if (status === network.statustype.connect) {
            this.updateStatus(null,'Connected');
        }
        if (status == network.statustype.disconnect) {
            this.updateStatus(null,'Disconnected');
        }
    }

    public onSend(json: string): void {
        console.log(`logger - ${json}`);
        this.updateStatus(null,'Request Sent');
    }

    // TODO : この機能を削除します
    public updateStatus(flagStatus = null, requestStatus = null) {
        // let elem;
        // if (flagStatus != null) {
        //      elem = document.createElement('span');
        //     elem.textContent = `${new Date().toLocaleString()} ' : ' ${flagStatus ? 'フラグ：ON' : 'フラグ：OFF'}`;
        //     document.getElementById('streamingLogContainer').appendChild(elem);
        // }
        // if (requestStatus != null) {
        //      elem = document.createElement('span');
        //     elem.textContent = `${new Date().toLocaleString()} ' : ' ${requestStatus}`;
        //     document.getElementById('streamingLogContainer').appendChild(elem);
        // }
        // if(elem)document.getElementById('streamingLogContainer').scrollTop = elem.offsetHeight + elem.offsetTop; 
    }

}
